module.exports = __webpack_public_path__ + "static/location-0ea26cf84b833d3ba9fac4ad31593b9b.png";